/**
 * Badge component
 */

import React from 'react';
import { clsx } from 'clsx';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'error' | 'warning' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  color?: string;
}

export function Badge({ children, variant = 'default', size = 'md', className, color }: BadgeProps) {
  const variantClasses = {
    default: 'bg-theme-surface text-theme-text border border-theme-border',
    success: 'bg-success-light text-success-dark',
    error: 'bg-error-light text-error-dark',
    warning: 'bg-warning-light text-warning-dark',
    info: 'bg-info-light text-info-dark',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  return (
    <span 
      className={clsx('inline-flex items-center font-medium rounded-full', variantClasses[variant], sizeClasses[size], className)}
      style={color ? { backgroundColor: `${color}20`, color: color, borderLeft: `4px solid ${color}` } : undefined}
    >
      {children}
    </span>
  );
}

